import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

// eslint-disable-next-line import/prefer-default-export

export const getListHost = (payload: any) =>
  sendGet("/api-client/host", payload);

export const createHost = (payload: any) =>
  sendPost("/api-client/host/create", payload);

export const deleteHost = (hostId: string) =>
  sendDelete(`/api-client/host/delete/${hostId}`);

export const updateHost = (payload: any) =>
  sendPut(`/api-client/host/update/${payload?.hostId}`, payload?.data);

export const updateHostStar = (payload: any) =>
  sendPut(`/api-client/host/update-star/${payload?.id}`, payload?.data);

export const syncDataHost = (payload: any) =>
  sendPut(`/api-client/host/sync-data`, payload);

export const updateHostIndex = (payload: any) =>
  sendPut(`/api-client/host/update-index`, payload);

export const updateHostSortIndex = (payload: any) =>
  sendPut(`/api-client/host/update-sort-index`, payload);

export const getListHostCount = (payload: any) =>
  sendGet("/api-client/host/list-host-count", payload);

export const updateHostPriority = (payload: any) =>
  sendPut(`/api-client/host/update-priority/${payload?.id}`, payload?.data);

export const checkExternalLink = (hostId: string) =>
  sendGet(`/api-client/host/check-link/${hostId}`, {});
